import { cloneDeep } from 'lodash';
import findResult, { findWithCodes } from '@/utils/resultsHelper';
import initialTemplatesState from '../templates/state/state';
import { catalogueCategories } from '../constants';

const initialState = {
  catalogues: { open: { results: [] } },
  ...initialTemplatesState,
};

export const cloneCatalogue = ({ catalogue }) => {
  const copy = cloneDeep(catalogue);
  copy.title = '';

  return copy;
};

export const findAllCatalogues = ({ catalogues }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(catalogues, catalogueCategories, codes);
};

export const findCatalogue = ({ catalogues }, { category, code }) => (
  findResult(catalogues, category, code)
);

export default initialState;
